export default __webpack_public_path__ + "static/media/SemiBold.89ece7ce.woff2";